define(function() { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 84);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * image service api version
 */

var API_VERSION = 'v1';

/**
 * Enum string values of requested image fitting types
 * Note: TILE_HORIZONTAL, TILE_VERTICAL, FIT_AND_TILE are supported for legacy purposes but are not exposed
 * in the documentation because they should not be exposed for new features
 * @type {{SCALE_TO_FILL: string, SCALE_TO_FIT: string, TILE: string, ORIGINAL_SIZE: string, STRETCH: string}}
 */
var fittingTypes = {
    SCALE_TO_FILL: 'fill',
    SCALE_TO_FIT: 'fit',
    STRETCH: 'stretch',
    ORIGINAL_SIZE: 'original_size',
    TILE: 'tile',
    TILE_HORIZONTAL: 'tile_horizontal',
    TILE_VERTICAL: 'tile_vertical',
    FIT_AND_TILE: 'fit_and_tile',
    LEGACY_STRIP_TILE: 'legacy_strip_tile',
    LEGACY_STRIP_TILE_HORIZONTAL: 'legacy_strip_tile_horizontal',
    LEGACY_STRIP_TILE_VERTICAL: 'legacy_strip_tile_vertical',
    LEGACY_STRIP_SCALE_TO_FILL: 'legacy_strip_fill',
    LEGACY_STRIP_SCALE_TO_FIT: 'legacy_strip_fit',
    LEGACY_STRIP_FIT_AND_TILE: 'legacy_strip_fit_and_tile',
    LEGACY_STRIP_ORIGINAL_SIZE: 'legacy_strip_original_size',
    LEGACY_ORIGINAL_SIZE: 'actual_size',
    LEGACY_FIT_WIDTH: 'fitWidth',
    LEGACY_FIT_HEIGHT: 'fitHeight',
    LEGACY_FULL: 'full',
    LEGACY_BG_FIT_AND_TILE: 'legacy_tile',
    LEGACY_BG_FIT_AND_TILE_HORIZONTAL: 'legacy_tile_horizontal',
    LEGACY_BG_FIT_AND_TILE_VERTICAL: 'legacy_tile_vertical',
    LEGACY_BG_NORMAL: 'legacy_normal'
};

/**
 * Enum string values of image transform types as passed to the image service api
 */
var transformTypes = {
    FIT: 'fit',
    FILL: 'fill',
    CROP: 'crop',
    LEGACY_CROP: 'legacy_crop'
};

/**
 * Enum string values of requested image align types
 * @type {{CENTER: string, RIGHT: string, LEFT: string, TOP: string, BOTTOM: string, TOP_RIGHT: string, TOP_LEFT: string, BOTTOM_RIGHT: string, BOTTOM_LEFT: string}}
 */
var alignTypes = {
    CENTER: 'center',
    TOP: 'top',
    TOP_LEFT: 'top_left',
    TOP_RIGHT: 'top_right',
    BOTTOM: 'bottom',
    BOTTOM_LEFT: 'bottom_left',
    BOTTOM_RIGHT: 'bottom_right',
    LEFT: 'left',
    RIGHT: 'right'
};

/**
 * Enum string values of image align types as passed to the image service
 */
var alignTypesMap = {
    'center': 'c',
    'top': 't',
    'top_left': 'tl',
    'top_right': 'tr',
    'bottom': 'b',
    'bottom_left': 'bl',
    'bottom_right': 'br',
    'left': 'l',
    'right': 'r'
};

/**
 * Enum string values of html tag used to construct the css or svg attributes
 *  @type {{BG: string, IMG: string, SVG: string}}
 */
var htmlTag = {
    BG: 'bg',
    IMG: 'img',
    SVG: 'svg'
};

/**
 * default unsharp mask values
 *  @type {{radius: number, amount: number, threshold: number}}
 */
var defaultUSM = {
    radius: 0.66,
    amount: 1.0,
    threshold: 0.01
};

/**
 * default empty data
 *  @type {{uri: '', css: {img: {}, container: {}}, attr: {img: {}, container: {}}}}
 */
var emptyData = {
    uri: '',
    css: {
        img: {},
        container: {}
    },
    attr: {
        img: {},
        container: {}
    }
};

/**
 * image qualities
 */
var imageQualityMap = {
    'HIGH': {
        size: 1400 * 1400,
        quality: 90,
        maxUpscale: 1
    },
    'MEDIUM': {
        size: 600 * 600,
        quality: 85,
        maxUpscale: 1
    },
    'LOW': {
        size: 400 * 400,
        quality: 80,
        maxUpscale: 1.2
    },
    'TINY': {
        size: 0,
        quality: 80,
        maxUpscale: 1.4
    }
};

/**
 * image quality
 * @type {{HIGH: string, MEDIUM: string, LOW: string, TINY: string}}
 */
var imageQuality = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
    TINY: 'TINY'
};

var fileType = {
    JPG: 'jpg',
    JPEG: 'jpeg',
    PNG: 'png',
    WEBP: 'webp',
    WIX_ICO_MP: 'wix_ico_mp',
    WIX_MP: 'wix_mp',
    GIF: 'gif',
    SVG: 'svg'
};

var webp = {
    LOSSLESS: 'lossless',
    LOSSY: 'lossy',
    ALPHA: 'alpha',
    ANIMATION: 'animation'
};

module.exports = {
    alignTypes: alignTypes,
    alignTypesMap: alignTypesMap,
    transformTypes: transformTypes,
    fittingTypes: fittingTypes,
    htmlTag: htmlTag,
    defaultUSM: defaultUSM,
    emptyData: emptyData,
    imageQuality: imageQuality,
    imageQualityMap: imageQualityMap,
    fileType: fileType,
    webp: webp,
    API_VERSION: API_VERSION

};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);
var globalFeatureSupportObject = __webpack_require__(81);

/**
 * Check once for browser support and store on global features support object
 * https://developers.google.com/speed/webp/faq#how_can_i_detect_browser_support_using_javascript
 */
function checkWEBPSupport(type) {
    var webpTypes = {
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };

    var webpImg = new window.Image();
    webpImg.onload = function () {
        var isWebpFeature = globalFeatureSupportObject.getFeature('isWEBP');
        isWebpFeature[type] = webpImg.width > 0 && webpImg.height > 0;
        globalFeatureSupportObject.setFeature('isWEBP', isWebpFeature);
    };

    webpImg.src = 'data:image/webp;base64,' + webpTypes[type];
}

/**
 * Populate the global feature support object with browser specific values
 */
function populateGlobalFeatureSupport() {
    if (typeof window !== 'undefined') {
        // jpg 2 webp
        checkWEBPSupport(constants.webp.LOSSY);
        // png 2 webp
        // checkWEBPSupport(constants.webp.LOSSLESS)
        // checkWEBPSupport(constants.webp.ALPHA)
        // 2 animation
        checkWEBPSupport(constants.webp.ANIMATION);

        // objectfit support
        globalFeatureSupportObject.setFeature('isObjectFitBrowser', isPropertySupported('objectFit'));
    }
}

/**
 * check if the browser supports webp image display
 * for the image source type
 * @param {string}    fileType
 *
 * @returns {boolean}
 */
function isWEBPBrowserSupport(fileType) {
    var isWebpFeature = globalFeatureSupportObject.getFeature('isWEBP');
    var isLosssyJPG = fileType === constants.fileType.JPG && isWebpFeature[constants.webp.LOSSY];
    var isLosslessPNG = fileType === constants.fileType.PNG && isWebpFeature[constants.webp.LOSSLESS];
    var isAlphaPNG = fileType === constants.fileType.PNG && isWebpFeature[constants.webp.ALPHA];

    return isLosssyJPG || isLosslessPNG && isAlphaPNG;
}

/**
 * check if the browser supports ObjectFit css attribute
 *
 * @returns {boolean}
 */
function isObjectFitBrowserSupport() {
    return globalFeatureSupportObject.getFeature('isObjectFitBrowser');
}

/**
 * returns if a css property is supported
 * @param property
 *
 * @returns {boolean}
 */
function isPropertySupported(property) {
    return property in window.document.documentElement.style;
}

/**
 * checks if image type is supported
 * @param {string}     uri      image source uri
 *
 * @returns {boolean}
 */
function isImageTypeSupported(uri) {
    var supportedImageExtensions = [constants.fileType.PNG, constants.fileType.JPEG, constants.fileType.JPG, constants.fileType.WIX_ICO_MP, constants.fileType.WIX_MP];
    return utils.includes(supportedImageExtensions, getFileExtension(uri));
}

/**
 * check request integrity
 * @param {string}                  fittingType         imageService.fittingTypes
 * @param {ImageTransformSource}    src
 * @param {ImageTransformTarget}    target
 *
 * @returns {boolean}
 */
function isValidRequest(fittingType, src, target) {
    return target && src && !isUrlEmptyOrNone(src.id) && utils.includes(constants.fittingTypes, fittingType);
}

/**
 * check if image transform is supported for source image
 * @param {string}     uri
 *
 * @returns {boolean}
 */
function isImageTransformApplicable(uri) {
    return isImageTypeSupported(uri) && !isExternalUrl(uri);
}

/**
 * returns true if image is of JPG type
 * @param {string}  uri
 *
 * @returns {boolean}
 */
function isJPG(uri) {
    return utils.includes(['jpg', 'jpeg'], getFileExtension(uri));
}

/**
 * returns true if image is of PNG type
 * @param {string}  uri
 *
 * @returns {boolean}
 */
function isPNG(uri) {
    return utils.includes(['png'], getFileExtension(uri));
}

/**
 * returns true if image is of webP type
 * @param {string}  uri
 *
 * @returns {boolean}
 */
function isWEBP(uri) {
    return utils.includes(['webp'], getFileExtension(uri));
}

/**
 * returns true if the url starts with http, https, // or data
 * @param {string}  url
 *
 * @returns {boolean}
 */
function isExternalUrl(url) {
    return (/(^https?)|(^data)|(^\/\/)/.test(url)
    );
}

/**
 * returns true if the url empty or none string
 * @param {string}  url
 *
 * @returns {boolean}
 */
function isUrlEmptyOrNone(url) {
    return !url || !url.trim() || url.toLowerCase() === 'none';
}

/**
 * returns source image file name (no extension)
 * @param {string}     uri      image source uri
 *
 * @returns {string}
 */
function getFileName(uri) {
    var fileName = uri;
    var beforeLeadingSlashRegexp = /\/(.*?)$/;
    var fileExtensionRegexp = /\.[^.]*$/;

    var trimmedFileName = beforeLeadingSlashRegexp.exec(uri);
    if (trimmedFileName && trimmedFileName[1]) {
        fileName = trimmedFileName[1];
    }
    return fileName.replace(fileExtensionRegexp, '');
}

/**
 * returns source image file name (no extension)
 * @param {string}     uri      image source uri
 *
 * @returns {string}
 */
function getFileType(uri) {
    if (isJPG(uri)) {
        return constants.fileType.JPG;
    } else if (isPNG(uri)) {
        return constants.fileType.PNG;
    } else if (isWEBP(uri)) {
        return constants.fileType.WEBP;
    }
}

/**
 * returns source image file extension
 * @param {string}     uri      image source uri
 *
 * @returns {string}
 */
function getFileExtension(uri) {
    var splitURI = /[.]([^.]+)$/.exec(uri);
    return (splitURI && /[.]([^.]+)$/.exec(uri)[1] || "").toLowerCase();
}

/**
 * returns scale factor needed if FIT fitting
 * @param {number}  sWidth
 * @param {number}  sHeight
 * @param {number}  dWidth
 * @param {number}  dHeight
 *
 * @returns {number}
 */
function getFitScaleFactor(sWidth, sHeight, dWidth, dHeight) {
    return Math.min(dWidth / sWidth, dHeight / sHeight);
}

/**
 * returns scale factor needed if FILL fitting
 * @param {number}  sWidth
 * @param {number}  sHeight
 * @param {number}  dWidth
 * @param {number}  dHeight
 *
 * @returns {number}
 */
function getFillScaleFactor(sWidth, sHeight, dWidth, dHeight) {
    return Math.max(dWidth / sWidth, dHeight / sHeight);
}

/**
 * returns scale factor source target
 * @param {number}  sWidth
 * @param {number}  sHeight
 * @param {number}  dWidth
 * @param {number}  dHeight
 * @param {string}  transformType
 *
 * @returns {number}
 */
function getScaleFactor(sWidth, sHeight, dWidth, dHeight, transformType) {
    var scaleFactor = void 0;

    if (transformType === constants.transformTypes.FILL) {
        scaleFactor = getFillScaleFactor(sWidth, sHeight, dWidth, dHeight);
    } else if (transformType === constants.transformTypes.FIT) {
        scaleFactor = getFitScaleFactor(sWidth, sHeight, dWidth, dHeight);
    } else {
        scaleFactor = 1;
    }

    return scaleFactor;
}

/**
 * returns the destination rectangle
 * @param {number}                  sWidth
 * @param {number}                  sHeight
 * @param {ImageTransformTarget}    target
 * @param {string}                  transformType
 *
 * @returns {object}                {with, height, scaleFactor}
 */
function getCalculatedTransformedData(sWidth, sHeight, target, transformType) {
    // device pixel aspect ratio
    var PAR = getPixelAspectRatio(target);
    // target rectangle
    var transformedData = {
        width: 0,
        height: 0,
        scaleFactor: 0,
        cssUpscaleNeeded: false
    };

    // adjust target rectangle
    var scaleFactor = getScaleFactor(sWidth, sHeight, target.width * PAR, target.height * PAR, transformType);
    var imageMaxAllowedUpscaleFactor = getPreferredUpscaleFactor(sWidth, sHeight);

    if (scaleFactor > imageMaxAllowedUpscaleFactor) {
        // server side image upscale is not allowed
        switch (transformType) {
            case constants.transformTypes.FILL:
                transformedData.width = target.width * PAR * (imageMaxAllowedUpscaleFactor / scaleFactor);
                transformedData.height = target.height * PAR * (imageMaxAllowedUpscaleFactor / scaleFactor);
                break;
            case constants.transformTypes.FIT:
                transformedData.width = sWidth * imageMaxAllowedUpscaleFactor;
                transformedData.height = sHeight * imageMaxAllowedUpscaleFactor;
                break;
            default:
                break;
        }
        // adjust scale factor value
        transformedData.scaleFactor = imageMaxAllowedUpscaleFactor;
        transformedData.cssUpscaleNeeded = true;
    } else {
        // server side image upscale is allowed
        switch (transformType) {
            case constants.transformTypes.FILL:
                transformedData.width = target.width * PAR;
                transformedData.height = target.height * PAR;
                break;
            case constants.transformTypes.FIT:
                transformedData.width = sWidth * scaleFactor;
                transformedData.height = sHeight * scaleFactor;
                break;
            default:
                break;
        }
        // adjust scale factor value
        transformedData.scaleFactor = scaleFactor;
        transformedData.cssUpscaleNeeded = false;
    }

    // return calculated transform size
    return transformedData;
}

/**
 * returns overlapping rectangle where sRect
 * id aligned (according to alignment) within dRect
 * @param {object}      sRect         rect 1
 * @param {object}      dRect         rect 2
 * @param {string}      alignment
 *
 * @returns {{x:number,y:number,width:number, height:number}}
 */
function getAlignedRect(sRect, dRect, alignment) {
    var x = void 0,
        y = void 0;

    // calculate cropping x,y
    switch (alignment) {
        case constants.alignTypes.CENTER:
            x = Math.max(0, (sRect.width - dRect.width) / 2);
            y = Math.max(0, (sRect.height - dRect.height) / 2);
            break;
        case constants.alignTypes.TOP:
            x = Math.max(0, (sRect.width - dRect.width) / 2);
            y = 0;
            break;
        case constants.alignTypes.TOP_LEFT:
            x = 0;
            y = 0;
            break;
        case constants.alignTypes.TOP_RIGHT:
            x = Math.max(0, sRect.width - dRect.width);
            y = 0;
            break;
        case constants.alignTypes.BOTTOM:
            x = Math.max(0, (sRect.width - dRect.width) / 2);
            y = Math.max(0, sRect.height - dRect.height);
            break;
        case constants.alignTypes.BOTTOM_LEFT:
            x = 0;
            y = Math.max(0, sRect.height - dRect.height);
            break;
        case constants.alignTypes.BOTTOM_RIGHT:
            x = Math.max(0, sRect.width - dRect.width);
            y = Math.max(0, sRect.height - dRect.height);
            break;
        case constants.alignTypes.LEFT:
            x = 0;
            y = Math.max(0, (sRect.height - dRect.height) / 2);
            break;
        case constants.alignTypes.RIGHT:
            x = Math.max(0, sRect.width - dRect.width);
            y = Math.max(0, (sRect.height - dRect.height) / 2);
            break;
    }

    // rect
    return {
        x: sRect.x ? sRect.x + x : x,
        y: sRect.y ? sRect.y + y : y,
        width: Math.min(sRect.width, dRect.width),
        height: Math.min(sRect.height, dRect.height)
    };
}

/**
 * returns overlapping rectangle between sRect and dRect
 * @param {object}      sRect         rect 1
 * @param {object}      dRect         rect 2
 *
 * @returns {{x:number,y:number,width:number, height:number} || null}
 */
function getOverlappingRect(sRect, dRect) {
    var width = Math.max(0, Math.min(sRect.width, dRect.x + dRect.width) - Math.max(0, dRect.x));
    var height = Math.max(0, Math.min(sRect.height, dRect.y + dRect.height) - Math.max(0, dRect.y));

    var isValidRect = width && height && (sRect.width !== width || sRect.height !== height);

    // return overlapping sRect/dRect rectangle(x, y, width, height)
    return isValidRect ? {
        x: Math.max(0, dRect.x),
        y: Math.max(0, dRect.y),
        width: width,
        height: height
    } : null;
}

/**
 * returns pixel aspect ratio value
 * @param {ImageTransformTarget}    target
 *
 * @returns {number}
 */
function getPixelAspectRatio(target) {
    return target.pixelAspectRatio || 1;
}

/**
 * returns target alignment value
 * @param {ImageTransformTarget}    target
 *
 * @returns {string}
 */
function getAlignment(target) {
    return constants.alignTypesMap[target.alignment] || constants.alignTypesMap[constants.alignTypes.CENTER];
}

/**
 * returns preferred image quality value
 * @param {number}    imageWidth
 * @param {number}    imageHeight
 *
 * @returns {number}
 */
function getPreferredImageQuality(imageWidth, imageHeight) {
    return constants.imageQualityMap[getImageQualityKey(imageWidth, imageHeight)].quality;
}

/**
 * returns permitted upscale factor
 * @param {number}    imageWidth
 * @param {number}    imageHeight
 *
 * @returns {number}
 */
function getPreferredUpscaleFactor(imageWidth, imageHeight) {
    return constants.imageQualityMap[getImageQualityKey(imageWidth, imageHeight)].maxUpscale;
}

/**
 * returns image quality key
 * @param {number}    imageWidth
 * @param {number}    imageHeight
 *
 * @returns {string}
 */
function getImageQualityKey(imageWidth, imageHeight) {
    var size = imageWidth * imageHeight;

    if (size > constants.imageQualityMap[constants.imageQuality.HIGH].size) {
        return constants.imageQuality.HIGH;
    } else if (size > constants.imageQualityMap[constants.imageQuality.MEDIUM].size) {
        return constants.imageQuality.MEDIUM;
    } else if (size > constants.imageQualityMap[constants.imageQuality.LOW].size) {
        return constants.imageQuality.LOW;
    }
    return constants.imageQuality.TINY;
}

/**
 * return the actual rounded dimension of a scaled rectangle
 * @param sWidth
 * @param sHeight
 * @param tWidth
 * @param tHeight
 * @param transformType
 * @returns {{width: number, height: number}}
 */
function getDimension(sWidth, sHeight, tWidth, tHeight, transformType) {
    var scaleFactor = getScaleFactor(sWidth, sHeight, tWidth, tHeight, transformType);
    return {
        width: Math.round(sWidth * scaleFactor),
        height: Math.round(sHeight * scaleFactor)
    };
}

module.exports = {
    populateGlobalFeatureSupport: populateGlobalFeatureSupport,
    isWEBPBrowserSupport: isWEBPBrowserSupport,
    isObjectFitBrowserSupport: isObjectFitBrowserSupport,
    isImageTransformApplicable: isImageTransformApplicable,
    isValidRequest: isValidRequest,
    isImageTypeSupported: isImageTypeSupported,
    isJPG: isJPG,
    isPNG: isPNG,
    isWEBP: isWEBP,
    getFileType: getFileType,
    getFileExtension: getFileExtension,
    getFileName: getFileName,
    getAlignedRect: getAlignedRect,
    getOverlappingRect: getOverlappingRect,
    getFitScaleFactor: getFitScaleFactor,
    getFillScaleFactor: getFillScaleFactor,
    getScaleFactor: getScaleFactor,
    getCalculatedTransformedData: getCalculatedTransformedData,
    getPixelAspectRatio: getPixelAspectRatio,
    getAlignment: getAlignment,
    getPreferredImageQuality: getPreferredImageQuality,
    getPreferredUpscaleFactor: getPreferredUpscaleFactor,
    getDimension: getDimension
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Shallow object 'extend' function.
 * Recieves any number of objects and assigns all by order to the first
 * @returns {{}}
 */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function assign() {
    var target = arguments[0] || {};
    var sources = Array.prototype.slice.call(arguments, 1, arguments.length);

    for (var i = 0; i < sources.length; i++) {
        var source = sources[i];
        for (var prop in source) {
            if (source.hasOwnProperty(prop)) {
                target[prop] = source[prop];
            }
        }
    }
    return target;
}

/**
 * return if an Array, String or Object includes a value
 * @param source
 * @param value
 * @returns {boolean}
 */
function includes(source, value) {
    // Array and String
    if (source.indexOf) {
        return source.indexOf(value) > -1;
    }
    // Object
    if (source && (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object') {
        return Object.keys(source).some(function (key) {
            return source[key] === value;
        });
    }
    return false;
}

/**
 * Simple templates.
 * Receives a string with es6 ${...} style template arguments and returns a transformed string.
 * @param string
 * @returns {Function}
 */
function template(string) {
    return function templateFunc(data) {
        var result = string;
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                result = result.replace(new RegExp('\\$\\{' + key + '\\}', 'g'), data[key]);
            }
        }
        return result;
    };
}

/**
 * Get the last element in an array
 * @param array
 * @returns {*}
 */
function last(array) {
    return array[array.length - 1];
}

module.exports = {
    assign: assign,
    includes: includes,
    last: last,
    template: template
};

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);
var backgroundAttributes = __webpack_require__(78);
var imgAttributes = __webpack_require__(79);
var SVGAttributes = __webpack_require__(77);
var imgPolyfillAttributes = __webpack_require__(80);

/**
 * get CSS or SVG attributes to be used in the browser
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns object
 */
function getAttributes(transformsObj, target) {
    var attributesGetter = void 0;

    if (target.htmlTag === constants.htmlTag.BG) {
        attributesGetter = backgroundAttributes;
    } else if (target.htmlTag === constants.htmlTag.SVG) {
        attributesGetter = SVGAttributes;
    } else if (imageServiceUtils.isObjectFitBrowserSupport()) {
        attributesGetter = imgAttributes;
    } else {
        attributesGetter = imgPolyfillAttributes;
    }

    return attributesGetter.get(transformsObj, target);
}

module.exports = {
    getAttributes: getAttributes
};

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);

// transform templates
var fitTemplate = utils.template("fit/w_${width},h_${height}");
var fillTemplate = utils.template("fill/w_${width},h_${height},al_${alignment}");
var cropTemplate = utils.template("crop/x_${x},y_${y},w_${width},h_${height}");
var legacyCropTemplate = utils.template("crop/w_${width},h_${height},al_${alignment}");
var upscaleTemplate = utils.template(",lg_1");

// options templates
var qualityTemplate = utils.template(",q_${quality}");
var unSharpMaskTemplate = utils.template(",usm_${radius}_${amount}_${threshold}");
var nonProgressiveTemplate = utils.template(",bl");

/**
 * returns image transform uri
 * @param {object}  transformsObj
 *
 * @returns {string}
 */
function getImageURI(transformsObj) {
    // construct image transforms
    var transformsObjStrArr = [];

    // construct transform
    transformsObj.parts.forEach(function (transformPart) {
        switch (transformPart.transformType) {
            case constants.transformTypes.CROP:
                transformsObjStrArr.push(cropTemplate(transformPart));
                break;

            case constants.transformTypes.LEGACY_CROP:
                transformsObjStrArr.push(legacyCropTemplate(transformPart));
                break;

            case constants.transformTypes.FIT:
                var fitStr = fitTemplate(transformPart);
                if (transformPart.upscale) {
                    fitStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(fitStr);
                break;

            case constants.transformTypes.FILL:
                var fillStr = fillTemplate(transformPart);
                if (transformPart.upscale) {
                    fillStr += upscaleTemplate(transformPart);
                }
                transformsObjStrArr.push(fillStr);
                break;
        }
    });

    var transformsStr = transformsObjStrArr.join("/");

    // construct transform options
    // quality
    if (transformsObj.fileType === constants.fileType.PNG && transformsObj.isWEBPSupport || transformsObj.fileType === constants.fileType.JPG) {
        transformsStr += qualityTemplate(transformsObj);
    }
    // un-sharp mask
    if (transformsObj.unsharpMask) {
        transformsStr += unSharpMaskTemplate(transformsObj.unsharpMask);
    }
    // progressive
    if (!transformsObj.progressive) {
        transformsStr += nonProgressiveTemplate(transformsObj);
    }

    // image url string
    return transformsObj.src.id + '/' + constants.API_VERSION + '/' + transformsStr + '/' + transformsObj.fileName + '.' + (transformsObj.isWEBPSupport ? 'webp' : transformsObj.fileExtension);
}

module.exports = {
    getImageURI: getImageURI
};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);

/**
 * returns image filters part of the image transform uri
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformOptions}   options
 */
function setTransformOptions(transformsObj, options) {
    options = options || {};

    transformsObj.quality = getQuality(transformsObj, options);
    transformsObj.unsharpMask = getUnsharpMask(transformsObj, options);
    transformsObj.progressive = getProgressive(options);
}

/**
 * returns progressive if required
 * @param {ImageTransformOptions}   options
 *
 * @returns {boolean}
 */
function getProgressive(options) {
    return options.progressive !== false;
}

/**
 * returns image filters part of the image transform uri
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformOptions}   options
 *
 * @returns {number}
 */
function getQuality(transformsObj, options) {
    var transformData = utils.last(transformsObj.parts);

    var defaultQuality = imageServiceUtils.getPreferredImageQuality(transformData.width, transformData.height);
    var quality = options.quality && options.quality >= 0 && options.quality <= 100 ? options.quality : defaultQuality;

    // return quality
    return parseInt(quality, 10);
}

/**
 * returns the desired transformed image unSharpMask values
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformOptions}   options
 *
 * @returns {object}
 */
function getUnsharpMask(transformsObj, options) {
    // construct usm values
    var usm = void 0;

    // If options.unsharpMask is a valid value, use it
    if (isUSMValid(options.unsharpMask)) {
        usm = {
            radius: options.unsharpMask.radius,
            amount: options.unsharpMask.amount,
            threshold: options.unsharpMask.threshold
        };
        // if options.unsharpMask is not all zeros and not valid and usm should be used, use default
    } else if (!isZeroUSM(options.unsharpMask)) {
        if (isUSMNeeded(transformsObj)) {
            usm = constants.defaultUSM;
        }
    }
    // If we got usm, change values to have trailing zeros (.00), else return undefined
    if (usm) {
        usm.radius = roundToFixed(usm.radius, 2);
        usm.amount = roundToFixed(usm.amount, 2);
        usm.threshold = roundToFixed(usm.threshold, 2);
    }

    return usm;
}

/**
 * indicates if usm is needed
 * @param {object}      transformsObj   transform parts object
 *
 * @returns {boolean}
 */
function isUSMNeeded(transformsObj) {
    // ---------------------------------------------------------------------------------------
    // do not apply usm if transformed image width & height is same as source image or larger
    // and no force usm is desired
    // ---------------------------------------------------------------------------------------
    var transformPart = utils.last(transformsObj.parts);
    var upscale = transformPart.scaleFactor >= 1;

    // return if usm is needed
    return !upscale || transformPart.forceUSM;
}

/**
 * indicates if all usm values are presented and in range
 * @param {object}  usm     unsharp mask
 *
 * @returns {boolean}
 */
function isUSMValid(usm) {
    usm = usm || {};
    var radius = typeof usm.radius !== 'undefined' && usm.radius >= 0.1 && usm.radius <= 500;
    var amount = typeof usm.amount !== 'undefined' && usm.amount >= 0 && usm.amount <= 10;
    var threshold = typeof usm.threshold !== 'undefined' && usm.threshold >= 0 && usm.threshold <= 255;

    // return is a valid USM data
    return radius && amount && threshold;
}

/**
 * indicates if all usm values are presented and are zero. an explicit request to not apply usm
 * @param {object}  usm     unsharp mask
 *
 * @returns {boolean}
 */
function isZeroUSM(usm) {
    usm = usm || {};
    return typeof usm.radius !== 'undefined' && usm.radius === 0 && typeof usm.amount !== 'undefined' && usm.amount === 0 && typeof usm.threshold !== 'undefined' && usm.threshold === 0;
}

/**
 * rounds number n digit precision and converts to string
 * @param {number}      value
 * @param {number}      precision
 *
 * @returns {string}
 */
function roundToFixed(value, precision) {
    var truncatePrecision = Math.pow(10, precision || 0);
    return (value * truncatePrecision / truncatePrecision).toFixed(parseInt(precision, 10));
}

module.exports = {
    setTransformOptions: setTransformOptions
};

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);

/**
 * request analysis, returns parsed transforms object
 * @param {object}                  transformsObj
 * @param {ImageTransformSource}    src
 * @param {ImageTransformTarget}    target
 */
function setTransformParts(transformsObj, src, target) {
    var rect = void 0;

    // crop source image if needed
    // set crop part and adjust source dimensions
    if (src.crop) {
        rect = imageServiceUtils.getOverlappingRect(src, src.crop);
        if (rect) {
            transformsObj.src.width = rect.width;
            transformsObj.src.height = rect.height;
            transformsObj.src.cropped = true;
            transformsObj.parts.push(getCropPart(rect));
        }
    }

    // set additional transform part
    switch (transformsObj.fittingType) {
        case constants.fittingTypes.SCALE_TO_FIT:
        case constants.fittingTypes.LEGACY_FIT_WIDTH:
        case constants.fittingTypes.LEGACY_FIT_HEIGHT:
        case constants.fittingTypes.LEGACY_FULL:
        case constants.fittingTypes.FIT_AND_TILE:
        case constants.fittingTypes.LEGACY_BG_FIT_AND_TILE:
        case constants.fittingTypes.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:
        case constants.fittingTypes.LEGACY_BG_FIT_AND_TILE_VERTICAL:
        case constants.fittingTypes.LEGACY_BG_NORMAL:
            // fit
            transformsObj.parts.push(getFitPart(transformsObj, target));
            break;

        case constants.fittingTypes.SCALE_TO_FILL:
            // fill
            transformsObj.parts.push(getFillPart(transformsObj, target));
            break;

        case constants.fittingTypes.STRETCH:
            // stretch
            transformsObj.parts.push(getStretchPart(transformsObj, target));
            break;

        case constants.fittingTypes.TILE_HORIZONTAL:
        case constants.fittingTypes.TILE_VERTICAL:
        case constants.fittingTypes.TILE:
        case constants.fittingTypes.LEGACY_ORIGINAL_SIZE:
        case constants.fittingTypes.ORIGINAL_SIZE:
            // use crop transform
            // if crop of source image was requested adjust cropping rectangle
            rect = imageServiceUtils.getAlignedRect(transformsObj.src, target, target.alignment);
            if (transformsObj.src.isCropped) {
                utils.assign(transformsObj.parts[0], rect);

                // update source width & height accordingly
                transformsObj.src.width = rect.width;
                transformsObj.src.height = rect.height;
            } else {
                transformsObj.parts.push(getCropPart(rect));
            }
            break;

        // ---------------------------------------------------------------------------------------
        // handles a legacy bug on bgImageStrip, background html tag
        // component Full Width Strip stored incorrect image source width and height
        // ---------------------------------------------------------------------------------------
        case constants.fittingTypes.LEGACY_STRIP_TILE_HORIZONTAL:
        case constants.fittingTypes.LEGACY_STRIP_TILE_VERTICAL:
        case constants.fittingTypes.LEGACY_STRIP_TILE:
        case constants.fittingTypes.LEGACY_STRIP_ORIGINAL_SIZE:
            // crop request of source image is not supported
            // use legacy crop
            transformsObj.parts.push(getLegacyCropPart(target));
            break;

        case constants.fittingTypes.LEGACY_STRIP_SCALE_TO_FIT:
        case constants.fittingTypes.LEGACY_STRIP_FIT_AND_TILE:
            // legacy fit
            transformsObj.parts.push(getLegacyFitPart(target));
            break;

        case constants.fittingTypes.LEGACY_STRIP_SCALE_TO_FILL:
            // legacy fill
            transformsObj.parts.push(getLegacyFillPart(target));
            break;
    }
}

/**
 * returns fit part of the image transform uri
 * @param {object}                  transformsObj
 * @param {ImageTransformTarget}    target
 *
 * @returns {object}
 */
function getFitPart(transformsObj, target) {
    // calculate the transformed image size needed
    var transformedData = imageServiceUtils.getCalculatedTransformedData(transformsObj.src.width, transformsObj.src.height, target, constants.transformTypes.FIT);

    // return fit transform data
    return {
        transformType: constants.transformTypes.FILL,
        width: Math.round(transformedData.width),
        height: Math.round(transformedData.height),
        alignment: constants.alignTypesMap.center,
        upscale: transformedData.scaleFactor > 1,

        forceUSM: false,
        scaleFactor: transformedData.scaleFactor,
        cssUpscaleNeeded: transformedData.cssUpscaleNeeded
    };
}

/**
 * returns fill part of the image transform uri
 * @param {object}                  transformsObj
 * @param {ImageTransformTarget}    target
 *
 * @returns {object}                {transformType, width, height, alignment, upscale, scaleFactor}
 */
function getFillPart(transformsObj, target) {
    // calculate the transformed image size needed
    var transformedData = imageServiceUtils.getCalculatedTransformedData(transformsObj.src.width, transformsObj.src.height, target, constants.transformTypes.FILL);

    // return fill transform data
    return {
        transformType: constants.transformTypes.FILL,
        width: Math.round(transformedData.width),
        height: Math.round(transformedData.height),
        alignment: imageServiceUtils.getAlignment(target),
        upscale: transformedData.scaleFactor > 1,

        forceUSM: false,
        scaleFactor: transformedData.scaleFactor,
        cssUpscaleNeeded: transformedData.cssUpscaleNeeded
    };
}

/**
 * returns fill part of the image transform uri
 * @param {object}                  transformsObj
 * @param {ImageTransformTarget}    target
 *
 * @returns {object}
 */
function getStretchPart(transformsObj, target) {
    // stretch data
    var scaleFactor = imageServiceUtils.getScaleFactor(transformsObj.src.width, transformsObj.src.height, target.width, target.height, constants.transformTypes.FILL);
    var clonedTarget = utils.assign({}, target);
    clonedTarget.width = transformsObj.src.width * scaleFactor;
    clonedTarget.height = transformsObj.src.height * scaleFactor;

    // return stretch part
    return getFitPart(transformsObj, clonedTarget);
}

/**
 * returns crop part of the image transform uri
 * @param {Object}  rect     x, y, width, height
 *
 * @returns {object}
 */
function getCropPart(rect) {
    // crop data
    return {
        transformType: constants.transformTypes.CROP,
        x: Math.round(rect.x),
        y: Math.round(rect.y),
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        upscale: false,

        forceUSM: false,
        scaleFactor: 1,
        cssUpscaleNeeded: false
    };
}

// ---------------------------------------------------------------------------------------
// handles a legacy bug on bgImageStrip, background html tag
// component Full Width Strip stored incorrect image source width and height
// ---------------------------------------------------------------------------------------

/**
 * returns fit part of the image transform uri
 * @param {ImageTransformTarget}    target
 *
 * @returns {object}
 */
function getLegacyFitPart(target) {
    // return fit part
    return {
        transformType: constants.transformTypes.FIT,
        width: Math.round(target.width),
        height: Math.round(target.height),
        upscale: false,

        forceUSM: true,
        scaleFactor: 1,
        cssUpscaleNeeded: false
    };
}

/**
 * returns fill part of the image transform uri
 * @param {ImageTransformTarget}    target
 *
 * @returns {object}
 */
function getLegacyFillPart(target) {
    // return fill part
    return {
        transformType: constants.transformTypes.FILL,
        width: Math.round(target.width),
        height: Math.round(target.height),
        alignment: imageServiceUtils.getAlignment(target),
        upscale: false,

        forceUSM: true,
        scaleFactor: 1,
        cssUpscaleNeeded: false
    };
}

/**
 * returns legacy crop part of the image transform uri
 * @param {ImageTransformTarget}     target
 *
 * @returns {object}
 */
function getLegacyCropPart(target) {
    // return crop part
    return {
        transformType: constants.transformTypes.LEGACY_CROP,
        width: Math.round(target.width),
        height: Math.round(target.height),
        alignment: imageServiceUtils.getAlignment(target),
        upscale: false,

        forceUSM: false,
        scaleFactor: 1,
        cssUpscaleNeeded: false
    };
}

module.exports = {
    setTransformParts: setTransformParts
};

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);

/**
 * get CSS or SVG attributes to be used in the browser
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns {{attr:{img: {}, container: {}}, css:{container:{}}}}
 */
function getSvgAttr(transformsObj, target) {
    var attributes = {
        css: {
            container: {}
        },
        attr: {
            container: {},
            img: {}
        }
    };
    var css = attributes.css;
    var attr = attributes.attr;
    var fittingType = transformsObj.fittingType;
    var fittingTypes = constants.fittingTypes;
    var sourceWidth = transformsObj.src.width;
    var sourceHeight = transformsObj.src.height;
    var imageScale = void 0;

    css.container.position = 'relative';

    // populate SVG attributes object
    switch (fittingType) {
        case fittingTypes.ORIGINAL_SIZE:
        case fittingTypes.LEGACY_ORIGINAL_SIZE:
            attr.img.width = transformsObj.src.width;
            attr.img.height = transformsObj.src.height;
            attr.img.x = '50%';
            attr.img.y = '50%';
            attr.img.transform = 'translate(' + -transformsObj.src.width / 2 + ',' + -transformsObj.src.height / 2 + ')';
            attr.img.preserveAspectRatio = 'xMidYMid slice';
            break;

        case fittingTypes.SCALE_TO_FIT:
        case fittingTypes.LEGACY_FIT_WIDTH:
        case fittingTypes.LEGACY_FIT_HEIGHT:
        case fittingTypes.LEGACY_FULL:
            imageScale = imageServiceUtils.getDimension(sourceWidth, sourceHeight, target.width, target.height, constants.transformTypes.FIT);
            attr.img.width = '100%';
            attr.img.height = '100%';
            attr.img.transform = '';
            attr.img.preserveAspectRatio = '';
            break;

        case fittingTypes.STRETCH:
            attr.img.width = target.width;
            attr.img.height = target.height;
            attr.img.x = 0;
            attr.img.y = 0;
            attr.img.transform = '';
            attr.img.preserveAspectRatio = 'none';
            break;

        case fittingTypes.SCALE_TO_FILL:
            if (!imageServiceUtils.isImageTransformApplicable(transformsObj.src.id)) {
                imageScale = imageServiceUtils.getDimension(sourceWidth, sourceHeight, target.width, target.height, constants.transformTypes.FILL);
                attr.img.width = imageScale.width;
                attr.img.height = imageScale.height;
            } else {
                attr.img.width = target.width;
                attr.img.height = target.height;
            }
            attr.img.x = 0;
            attr.img.y = 0;
            attr.img.transform = '';
            attr.img.preserveAspectRatio = 'xMidYMid slice';
            break;
    }
    //attr.container.position = 'relative';
    attr.container.width = target.width;
    attr.container.height = target.height;
    attr.container.viewBox = [0, 0, target.width, target.height].join(' ');

    //todo: currently all svg images are center aligned , needs to implement alignment when needed.
    // return attributes object
    return attributes;
}

module.exports = {
    get: getSvgAttr
};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1);

/**
 * returns BG tag CSS data
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns {{css: {container: {}}}}
 */
function getCSS(transformsObj, target) {
    var attributes = {
        css: {
            container: {}
        }
    };
    var css = attributes.css;
    var alignTypes = constants.alignTypes;
    var fittingType = transformsObj.fittingType;
    var fittingTypes = constants.fittingTypes;

    //set fitting
    switch (fittingType) {
        case fittingTypes.ORIGINAL_SIZE:
        case fittingTypes.LEGACY_ORIGINAL_SIZE:
        case fittingTypes.LEGACY_STRIP_ORIGINAL_SIZE:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "no-repeat";
            break;

        case fittingTypes.SCALE_TO_FIT:
        case fittingTypes.LEGACY_STRIP_SCALE_TO_FIT:
            css.container.backgroundSize = "contain";
            css.container.backgroundRepeat = "no-repeat";
            break;

        case fittingTypes.STRETCH:
            css.container.backgroundSize = "100% 100%";
            css.container.backgroundRepeat = "no-repeat";
            break;

        case fittingTypes.SCALE_TO_FILL:
        case fittingTypes.LEGACY_STRIP_SCALE_TO_FILL:
            css.container.backgroundSize = "cover";
            css.container.backgroundRepeat = "no-repeat";
            break;

        case fittingTypes.TILE_HORIZONTAL:
        case fittingTypes.LEGACY_STRIP_TILE_HORIZONTAL:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat-x";
            break;

        case fittingTypes.TILE_VERTICAL:
        case fittingTypes.LEGACY_STRIP_TILE_VERTICAL:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat-y";
            break;

        case fittingTypes.TILE:
        case fittingTypes.LEGACY_STRIP_TILE:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat";
            break;

        case fittingTypes.FIT_AND_TILE:
        case fittingTypes.LEGACY_STRIP_FIT_AND_TILE:
            css.container.backgroundSize = "contain";
            css.container.backgroundRepeat = "repeat";
            break;

        // Legacy old editor bg types.
        case fittingTypes.LEGACY_BG_FIT_AND_TILE:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat";
            break;

        case fittingTypes.LEGACY_BG_FIT_AND_TILE_HORIZONTAL:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat-x";
            break;

        case fittingTypes.LEGACY_BG_FIT_AND_TILE_VERTICAL:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "repeat-y";
            break;

        case fittingTypes.LEGACY_BG_NORMAL:
            css.container.backgroundSize = "auto";
            css.container.backgroundRepeat = "no-repeat";
            break;
    }

    // set alignment
    switch (target.alignment) {
        case alignTypes.CENTER:
            css.container.backgroundPosition = "center center"; //50% 50%
            break;

        case alignTypes.LEFT:
            css.container.backgroundPosition = "left center"; //0% 50%
            break;

        case alignTypes.RIGHT:
            css.container.backgroundPosition = "right center"; //100% 50%
            break;

        case alignTypes.TOP:
            css.container.backgroundPosition = "center top"; //50% 0%
            break;

        case alignTypes.BOTTOM:
            css.container.backgroundPosition = "center bottom"; //50% 100%
            break;

        case alignTypes.TOP_RIGHT:
            css.container.backgroundPosition = "right top"; //100% 0%
            break;

        case alignTypes.TOP_LEFT:
            css.container.backgroundPosition = "left top"; //0% 0%
            break;

        case alignTypes.BOTTOM_RIGHT:
            css.container.backgroundPosition = "right bottom"; //100% 100%
            break;

        case alignTypes.BOTTOM_LEFT:
            css.container.backgroundPosition = "left bottom"; //0% 100%
            break;

    }

    // return background CSS
    return attributes;
}

module.exports = {
    get: getCSS
};

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__(1);

/**
 * returns image tag CSS data
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns {{css: {img: {}, container: {}}}}
 */
function getCSS(transformsObj, target) {
    var attributes = {
        css: {
            container: {},
            img: {}
        }
    };
    var css = attributes.css;
    var fittingType = transformsObj.fittingType;
    var alignType = target.alignment;

    var fittingTypes = constants.fittingTypes;
    var alignTypes = constants.alignTypes;

    css.container.position = 'relative';

    switch (fittingType) {
        case fittingTypes.ORIGINAL_SIZE:
        case fittingTypes.LEGACY_ORIGINAL_SIZE:
            if (transformsObj.parts && transformsObj.parts.length) {
                css.img.width = transformsObj.parts[0].width;
                css.img.height = transformsObj.parts[0].height;
            } else {
                css.img.width = transformsObj.src.width;
                css.img.height = transformsObj.src.height;
            }
            break;

        case fittingTypes.SCALE_TO_FIT:
        case fittingTypes.LEGACY_FIT_WIDTH:
        case fittingTypes.LEGACY_FIT_HEIGHT:
        case fittingTypes.LEGACY_FULL:
            css.img.width = target.width;
            css.img.height = target.height;
            css.img.objectFit = 'contain';
            break;

        case fittingTypes.STRETCH:
            css.img.width = target.width;
            css.img.height = target.height;
            css.img.objectFit = 'fill';
            break;

        case fittingTypes.SCALE_TO_FILL:
            css.img.width = target.width;
            css.img.height = target.height;
            css.img.objectFit = 'cover';
            break;
    }

    // set alignment in a private case where the image src is smaller than the image element,
    if (css.img.width !== target.width || css.img.height !== target.height) {
        var verticalMiddle = Math.round((target.height - css.img.height) / 2);
        var horizontalMiddle = Math.round((target.width - css.img.width) / 2);
        css.img.position = 'absolute';
        css.img.top = 'auto';
        css.img.right = 'auto';
        css.img.bottom = 'auto';
        css.img.left = 'auto';

        switch (alignType) {
            default:
            case alignTypes.CENTER:
                css.img.width = target.width;
                css.img.height = target.height;
                css.img.objectFit = 'none';
                break;

            case alignTypes.LEFT:
                css.img.left = 0;
                css.img.top = verticalMiddle;
                //0% 50%
                break;

            case alignTypes.RIGHT:
                css.img.right = 0;
                css.img.top = verticalMiddle;
                //100% 50%
                break;

            case alignTypes.TOP:
                css.img.left = horizontalMiddle;
                css.img.top = 0;
                //50% 0%
                break;

            case alignTypes.BOTTOM:
                css.img.left = horizontalMiddle;
                css.img.bottom = 0;
                //50% 100%
                break;

            case alignTypes.TOP_RIGHT:
                css.img.right = 0;
                css.img.top = 0;
                //100% 0%
                break;

            case alignTypes.TOP_LEFT:
                css.img.left = 0;
                css.img.top = 0;
                //0% 0%
                break;

            case alignTypes.BOTTOM_RIGHT:
                css.img.right = 0;
                css.img.bottom = 0;
                //100% 100%
                break;

            case alignTypes.BOTTOM_LEFT:
                css.img.left = 0;
                css.img.bottom = 0;
                //0% 100%
                break;

        }
    }

    return attributes;
}

module.exports = {
    get: getCSS
};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);

/**
 * returns alternative Image tag CSS data
 * @param {object}                  transformsObj    transform parts object
 * @param {ImageTransformTarget}    target
 *
 * @returns {{css: {img: {}, container: {}}}}
 */
function getCSS(transformsObj, target) {
    var attributes = {
        css: {
            container: {},
            img: {}
        }
    };
    var css = attributes.css;
    var fittingType = transformsObj.fittingType;
    var fittingTypes = constants.fittingTypes;
    var alignType = target.alignment;
    var alignTypes = constants.alignTypes;
    var sourceWidth = void 0;
    var sourceHeight = void 0;
    if (transformsObj.parts && transformsObj.parts.length) {
        sourceWidth = transformsObj.parts[0].width;
        sourceHeight = transformsObj.parts[0].height;
    } else {
        sourceWidth = transformsObj.src.width;
        sourceHeight = transformsObj.src.height;
    }
    var cssValues = void 0;

    css.img.display = 'block';
    css.container.position = 'relative';
    css.img.position = 'absolute';
    css.img.top = 'auto';
    css.img.right = 'auto';
    css.img.bottom = 'auto';
    css.img.left = 'auto';

    // set css
    switch (fittingType) {
        case fittingTypes.ORIGINAL_SIZE:
        case fittingTypes.LEGACY_ORIGINAL_SIZE:
            css.img.width = sourceWidth;
            css.img.height = sourceHeight;
            break;
        case fittingTypes.SCALE_TO_FIT:
        case fittingTypes.LEGACY_FIT_WIDTH:
        case fittingTypes.LEGACY_FIT_HEIGHT:
        case fittingTypes.LEGACY_FULL:
            cssValues = imageServiceUtils.getDimension(sourceWidth, sourceHeight, target.width, target.height, constants.transformTypes.FIT);
            utils.assign(css.img, cssValues);
            break;

        case fittingTypes.STRETCH:
            css.img.width = target.width;
            css.img.height = target.height;
            break;

        case fittingTypes.SCALE_TO_FILL:
            if (!imageServiceUtils.isImageTransformApplicable(transformsObj.src.id)) {
                cssValues = imageServiceUtils.getDimension(sourceWidth, sourceHeight, target.width, target.height, constants.transformTypes.FILL);
                utils.assign(css.img, cssValues);
                css.container.overflow = 'hidden';
            } else {
                css.img.width = target.width;
                css.img.height = target.height;
            }
            break;
    }

    //no need to align when sizing are the same
    if (css.img.width !== target.width || css.img.height !== target.height) {
        var verticalMiddle = Math.round((target.height - css.img.height) / 2);
        var horizontalMiddle = Math.round((target.width - css.img.width) / 2);

        switch (alignType) {
            default:
            case alignTypes.CENTER:
                css.img.top = verticalMiddle;
                css.img.left = horizontalMiddle;
                break;

            case alignTypes.LEFT:
                css.img.left = 0;
                css.img.top = verticalMiddle;
                //0% 50%
                break;

            case alignTypes.RIGHT:
                css.img.right = 0;
                css.img.top = verticalMiddle;
                //100% 50%
                break;

            case alignTypes.TOP:
                css.img.left = horizontalMiddle;
                css.img.top = 0;
                //50% 0%
                break;

            case alignTypes.BOTTOM:
                css.img.left = horizontalMiddle;
                css.img.bottom = 0;
                //50% 100%
                break;

            case alignTypes.TOP_RIGHT:
                css.img.right = 0;
                css.img.top = 0;
                //100% 0%
                break;

            case alignTypes.TOP_LEFT:
                css.img.left = 0;
                css.img.top = 0;
                //0% 0%
                break;

            case alignTypes.BOTTOM_RIGHT:
                css.img.right = 0;
                css.img.bottom = 0;
                //100% 100%
                break;

            case alignTypes.BOTTOM_LEFT:
                css.img.left = 0;
                css.img.bottom = 0;
                //0% 100%
                break;

        }
    }
    // returns alternative Image tag CSS data
    return attributes;
}

module.exports = {
    get: getCSS
};

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Global MUTABLE support object
 * For tests, override the getFeature function and not the object
 * @type {{isWEBP: {lossless: boolean, lossy: boolean, alpha: boolean, animation: boolean}, isObjectFitBrowser: boolean}}
 */

var globalFeaturesSupportObj = {
    /**
     * checks if the browser supports webp image type
     * @type {object<boolean>}
     */
    isWEBP: {
        lossless: false,
        lossy: false,
        alpha: false,
        animation: false
    },
    /**
     * checks if the browser supports 'objectFit'
     * @type {boolean}
     */
    isObjectFitBrowser: false
};

module.exports = {
    getFeature: function getFeature(feature) {
        return globalFeaturesSupportObj[feature];
    },
    setFeature: function setFeature(feature, value) {
        globalFeaturesSupportObj[feature] = value;
    }
};

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(3);
var constants = __webpack_require__(1);
var imageServiceUtils = __webpack_require__(2);
var transformParts = __webpack_require__(67);
var transformOptions = __webpack_require__(66);
var transforms = __webpack_require__(65);
var attributes = __webpack_require__(64);

/**
 * returns image transform uri and the
 * needed css for alignment and positioning
 * @param {string}                  fittingType         imageServicesTypes.fittingTypes
 * @param {ImageTransformSource}    src                 source image
 * @param {ImageTransformTarget}    target              target component
 * @param {ImageTransformOptions}   options           transform options
 *
 * @returns {{uri: string, css: {img: {}, container: {}}} | {uri: string, attr: {img: {}, container: {}}} | {}}
 */
function getData(fittingType, src, target, options) {
    var data = {};
    var fileType = imageServiceUtils.getFileType(src.id),
        fileName = imageServiceUtils.getFileName(src.id),
        fileExtension = imageServiceUtils.getFileExtension(src.id),
        isWEBPSupport = imageServiceUtils.isWEBPBrowserSupport(fileType);

    var transformsObj = {
        fileName: fileName,
        fileExtension: fileExtension,
        fileType: fileType,
        isWEBPSupport: isWEBPSupport,
        fittingType: fittingType,
        src: {
            id: src.id,
            width: src.width,
            height: src.height,
            isCropped: false
        },
        quality: 0,
        progressive: true,
        unsharpMask: {},
        parts: []
    };

    // check if valid request
    if (imageServiceUtils.isValidRequest(fittingType, src, target)) {
        // check if image transformation is applicable (e.g. .gif, .wix_mp)
        if (imageServiceUtils.isImageTransformApplicable(src.id)) {
            transformParts.setTransformParts(transformsObj, src, target);
            transformOptions.setTransformOptions(transformsObj, options);

            // set the uri property
            data.uri = transforms.getImageURI(transformsObj);
        } else {
            data.uri = src.id;
        }

        //set the CSS or the SVG property
        utils.assign(data, attributes.getAttributes(transformsObj, target));
    } else {
        // empty data
        data = constants.emptyData;
    }

    // return data to be used in html
    return data;
}

module.exports = {
    populateGlobalFeatureSupport: imageServiceUtils.populateGlobalFeatureSupport,
    getData: getData,
    fittingTypes: constants.fittingTypes,
    alignTypes: constants.alignTypes,
    htmlTag: constants.htmlTag
};

/***/ })

/******/ })});;


// WEBPACK FOOTER //
// imageClientApi.js